import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import gql from 'graphql-tag';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { QueryResult } from 'src/app/shared/object/queryResult.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { DatesService } from 'src/app/shared/services/dates.service';

@Component({
  selector: 'app-modal-seleccion-documento',
  templateUrl: './modal-seleccion-documento.component.html',
  styleUrls: ['./modal-seleccion-documento.component.scss'],
  providers: [SecurityService],
})
export class ModalSeleccionDocumentoComponent implements OnInit {
  // Input
  @Input() tipo_dte_codigo: number = 0;
  @Input() es_nc: boolean = false;
  @Input() es_nd: boolean = false;

  // Output
  @Output() onSelect: EventEmitter<any> = new EventEmitter<any>();
  @Output() onNotFound: EventEmitter<any> = new EventEmitter<any>();

  // Modales
  @ViewChild('seleccionarFactura', { static: true }) seleccionarFacturaModal: ModalDirective;

  // Form
  formData: FormGroup;

  // Data
  private rutEmpresa: Number;
  private sucursalEmpresa: Number;
  data: any = [];
  paginationContext: PaginationContext = new PaginationContext();
  busquedaIniciada: boolean = false;
  loading: boolean = false;

  // Utils
  private log: any;

  constructor(
    private gqlclient: GraphQLClient,
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private clog: ConsoleService,
    private messageRendererService: MessageRendererService,
    private rutService: RutService,
    private datesService: DatesService
  ) {
    this.log = this.clog.log('MODAL-SELECCION-FACTURA');
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo());

    this.paginationContext.RecordsByPage = 10;

    this.createForm();
  }

  createForm() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth();
    this.formData = this.fb.group({
      folio: [null],
      rut: [null],
      fechaDesde: [initDate, [Validators.required]],
      fechaHasta: [currentDate, [Validators.required]],
      nombre: [null],
    });
  }

  show(cleanData: Boolean = true) {
    if (cleanData) {
      this.cleanAll();
    }
    this.seleccionarFacturaModal.show();
  }

  hide() {
    this.seleccionarFacturaModal.hide();
  }

  private cleanAll() {
    this.cleanFormData();
    this.cleanResultData();
  }

  private cleanFormData() {
    this.formData.reset();
    this.formData.markAsPristine();
    this.formData.markAsUntouched();

    this.initializeFormData();
  }

  private cleanResultData() {
    this.busquedaIniciada = false;
    this.data = [];
    this.loading = false;
  }

  private initializeFormData() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth();
    this.formData.get('folio').setValue(null);
    this.formData.get('rut').setValue(null);
    this.formData.get('fechaDesde').setValue(initDate);
    this.formData.get('fechaHasta').setValue(currentDate);
    this.formData.get('nombre').setValue(null);
  }

  /********* OPERATIONS *********/
  buscarTodos(fromStartPage: Boolean = false) {
    if (fromStartPage) this.paginationContext.CurrentPage = 1;

    // limpiar datos antes de desplegar
    this.cleanResultData();
    const inputParams = this.createInputParamsBuscarTodos();
    this.loading = true;
    this.executeQueryBuscarTodos(inputParams, (result) => this.renderQueryResults(result));
  }

  // rut
  // fechaDesde
  // fechaHasta
  // nombre

  private createInputParamsBuscarTodos() {
    const { folio, rut, nombre } = this.formData.value;
    let rutSinDv = 0;
    if (rut) rutSinDv = this.rutService.QuitarDV(this.rutService.Limpiar(rut));
    let payload: any = {
      rut_emisor: this.rutEmpresa,
      sucursal_codigo: this.sucursalEmpresa,
      tipo_dte_codigo: this.tipo_dte_codigo ? this.tipo_dte_codigo : 0, //TODO: **tipo_dte_codigo** puede ser 0, pero lo mejor es enviar el valor de **Docto. Ref**
      es_nc: this.es_nc ? this.es_nc : false, //TODO: **tipo_dte_codigo** puede ser 0, pero lo mejor es enviar el valor de **Docto. Ref**
      es_nd: this.es_nd ? this.es_nd : false, //TODO: **tipo_dte_codigo** puede ser 0, pero lo mejor es enviar el valor de **Docto. Ref**
      folio: folio ? folio : 0,
      cliente_proveedor_rut: rut ? rutSinDv : 0,
      cliente_nombre: nombre ? nombre : '',
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage,
    };

    if (this.formData.get('fechaDesde').value) payload.fecha_desde = this.formData.get('fechaDesde').value;

    if (this.formData.get('fechaHasta').value) payload.fecha_hasta = this.formData.get('fechaHasta').value;

    return payload;
  }

  private renderQueryResults(result: QueryResult) {
    const { registros, paginaActual, totalPaginas, totalRegistros } = result;
    this.log('registros', registros, result);
    this.loading = false;
    this.paginationContext.RecordsCount = totalRegistros;
    this.paginationContext.CurrentPage = paginaActual;
    this.paginationContext.PagesCount = totalPaginas;
    this.data = registros;
    this.data.forEach((element) => {
      // delete element.__typename
      this.cleanIncomingData(element);
    });
    this.busquedaIniciada = true;
  }

  private cleanIncomingData(register: any) {
    delete register.__typename;
  }

  private executeQueryBuscarTodos(inputParams: any, callback: Function) {
    const self = this;
    this.log('inputParams', JSON.stringify(inputParams));
    this.gqlclient.query(
      {
        query: gql`
          query (
            $rut_emisor: Decimal
            $sucursal_codigo: Decimal
            $folio: Decimal
            $tipo_dte_codigo: Decimal
            $fecha_desde: Date
            $fecha_hasta: Date
            $cliente_proveedor_rut: Decimal
            $cliente_nombre: String
            $es_nc: Boolean
            $es_nd: Boolean
            $paginaActual: Int
            $cantidadRegistrosPorPagina: Int
          ) {
            documento {
              obtenerTodosDocumentos(
                entidad: {
                  tipo_dte_codigo: $tipo_dte_codigo
                  rut_emisor: $rut_emisor
                  sucursal_codigo: $sucursal_codigo
                  folio: $folio
                  fecha_desde: $fecha_desde
                  fecha_hasta: $fecha_hasta
                  cliente_proveedor_rut: $cliente_proveedor_rut
                  cliente_nombre: $cliente_nombre
                  es_nc: $es_nc
                  es_nd: $es_nd
                }
                paginaActual: $paginaActual
                cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina
              ) {
                mensajes {
                  codigo
                  contexto
                  tipo
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rut_emisor
                    sucursal_codigo
                    folio
                    tipo_dte_codigo
                    cliente_proveedor_rut
                    tipo_envio_codigo
                    tipo_traslado_codigo
                    condicion_pago_codigo
                    vendedor_codigo
                    tipo_devolucion_codigo
                    fecha_emision
                    rut_receptor
                    direccion_completa_facturacion
                    comuna_facturacion
                    provincia_facturacion
                    region_facturacion
                    direccion_completa_despacho
                    comuna_despacho
                    princia_despacho
                    region_despacho
                    giro_cliente
                    fono_cliente
                    monto_descuento
                    monto_recargo
                    subtotal_neto
                    monto_total_neto
                    monto_iva
                    monto_afecto
                    monto_exento
                    subtotal
                    monto_total
                    nota_venta
                    orden_compra
                    fecha_registro
                    aplica_rebaja
                    aplica_recorrido
                    observaciones
                    ticket_sii
                    fecha_vencimiento
                    dia_emision
                    mes_emision
                    id_lsoft
                    motivo_devolucion_codigo
                    tipo_despacho_codigo
                    centro_costo_codigo
                    forma_pago_codigo
                    tipo_destinatario_codigo
                    es_entrega_gratuita
                    direccion_codigo
                    usuario_rut_usuario
                    tipo_ncnd_codigo
                    glosa_administrativa
                    cliente_nombre
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (_respuesta) {
        const { mensajes, respuesta } = _respuesta.data.documento.obtenerTodosDocumentos;
        const ok = mensajes.filter((m) => m.tipo === 'ERROR').length === 0;
        if (!ok) {
          self.messageRendererService.showErrors(mensajes);
          callback(new QueryResult(null, 0, 0, 0));
          return;
        }

        const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta;

        // callback({ registros, paginaActual, totalPaginas, totalRegistros })
        callback(new QueryResult(registros, paginaActual, totalPaginas, totalRegistros));
      }
    );
  }

  public executeQueryBuscarDocumentoByFolio({ folio, tipo_dte_codigo }, callback: Function) {
    const inputParams = {
      rut_emisor: this.rutEmpresa,
      sucursal_codigo: this.sucursalEmpresa,
      folio,
      tipo_dte_codigo: tipo_dte_codigo, // TODO: Dummy data
      es_nc: this.es_nc ? this.es_nc : false, //TODO: **tipo_dte_codigo** puede ser 0, pero lo mejor es enviar el valor de **Docto. Ref**
      es_nd: this.es_nd ? this.es_nd : false, //TODO: **tipo_dte_codigo** puede ser 0, pero lo mejor es enviar el valor de **Docto. Ref**
    };

    this.log('inputParams', JSON.stringify(inputParams));
    const self = this;
    this.gqlclient.query(
      {
        query: gql`
          query ($rut_emisor: Decimal, $sucursal_codigo: Decimal, $folio: Decimal, $tipo_dte_codigo: Decimal, $es_nc: Boolean, $es_nd: Boolean) {
            documento {
              obtenerDocumento(
                filtro: { exacto: { cabecera: { rut_emisor: $rut_emisor, sucursal_codigo: $sucursal_codigo, folio: $folio, tipo_dte_codigo: $tipo_dte_codigo, es_nc: $es_nc, es_nd: $es_nd } } }
              ) {
                mensajes {
                  codigo
                  contexto
                  tipo
                  texto
                }
                respuesta {
                  cabecera {
                    rut_emisor
                    sucursal_codigo
                    folio
                    tipo_dte_codigo
                    cliente_proveedor_rut
                    tipo_envio_codigo
                    tipo_traslado_codigo
                    condicion_pago_codigo
                    vendedor_codigo
                    tipo_devolucion_codigo
                    fecha_emision
                    rut_receptor
                    direccion_completa_facturacion
                    comuna_facturacion
                    provincia_facturacion
                    region_facturacion
                    direccion_completa_despacho
                    comuna_despacho
                    princia_despacho
                    region_despacho
                    giro_cliente
                    fono_cliente
                    monto_descuento
                    monto_recargo
                    subtotal_neto
                    monto_total_neto
                    monto_iva
                    monto_afecto
                    monto_exento
                    subtotal
                    monto_total
                    nota_venta
                    orden_compra
                    fecha_registro
                    aplica_rebaja
                    aplica_recorrido
                    observaciones
                    ticket_sii
                    fecha_vencimiento
                    dia_emision
                    mes_emision
                    id_lsoft
                    motivo_devolucion_codigo
                    tipo_despacho_codigo
                    centro_costo_codigo
                    forma_pago_codigo
                    tipo_destinatario_codigo
                    es_entrega_gratuita
                    direccion_codigo
                    usuario_rut_usuario
                    tipo_ncnd_codigo
                    glosa_administrativa
                    cliente_nombre
                    vendedor_nombre
                    direccion_nombre
                    tipo_dte_nombre
                    unidad_negocio_codigo
                    lista_precio_codigo
                  }
                  descuentosGlobales {
                    rut_emisor
                    folio
                    tipo_dte_codigo
                    es_porcentaje
                    monto_descuento
                    es_descuento
                    glosa
                    ind_facturacion
                    es_exento
                  }
                  detalleDocumento {
                    rut_emisor
                    folio
                    tipo_dte_codigo
                    nro_linea
                    producto_codigo
                    formato_original
                    formato_codigo
                    formato_nombre
                    descripcion_producto
                    cantidad
                    cantidad_original
                    precio_neto
                    precio_unitario
                    monto_total_neto
                    monto_total
                    es_producto_libre
                    es_facturable
                    es_exento
                    gasto_codigo
                    equivalencia_producto_id
                    sku
                    motivo_devolucion_especifico_codigo
                    es_correcion_monto
                    aplicacion_descuento
                    aplicacion_recargo
                    aplicacion_imp_adic
                    unidad_negocio_codigo
                    noEsProductoOriginal
                    precio_unitario_original
                    listaProductoFormato {
                      producto_codigo
                      formato_codigo
                      formato_nombre
                      formato_codigo_top
                      formato_secundario
                      cantidad
                      label
                      value
                    }
                    atributos {
                      rut_emisor
                      folio
                      tipo_dte_codigo
                      tipo_atributo_codigo
                      nro_linea
                      impuesto_codigo
                      porcentaje
                      monto
                      es_porcentaje
                    }
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (_respuesta) {
        const { mensajes, respuesta } = _respuesta.data.documento.obtenerDocumento;
        const ok = mensajes.filter((m) => m.tipo === 'ERROR').length === 0;
        if (!ok) {
          self.messageRendererService.showErrors(mensajes);
          callback(null);
          return;
        }

        delete respuesta.__typename;

        // const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta
        // callback(new QueryResult(registros, paginaActual, totalPaginas, totalRegistros))
        callback(respuesta);
      }
    );
  }

  onPageChange(context: PaginationContext) {
    this.paginationContext.CurrentPage = context.RequestedPage;
    this.buscarTodos();
  }

  // Se consume desde la vista
  selectData(documento) {
    this.executeQueryBuscarDocumentoByFolio(documento, (result: any) => {
      if (result) {
        this.emitirSeleccionado(result);
        this.hide();
      }
    });
  }

  private emitirSeleccionado(data) {
    this.lastFolio = data.cabecera.folio;
    this.lastFechaEmision = data.cabecera.fecha_emision;
    this.onSelect.emit({
      data,
    });
  }

  private emitirNotFound() {
    this.onNotFound.emit();
  }

  // Método para ser consumido desde fuera del componente
  lastFolio: any = null;
  lastFechaEmision: any = null;
  searchByNroDoc(folio: any, tipo_dte_codigo: any) {
    if (folio === this.lastFolio) return;
    this.executeQueryBuscarDocumentoByFolio(
      {
        folio,
        tipo_dte_codigo,
      },
      (result: any) => {
        this.log('searchByNroDoc', result);
        if (result) this.emitirSeleccionado(result);
        else this.emitirNotFound();
        this.hide();
      }
    );
  }

  clearLast() {
    this.lastFolio = null;
  }
  /********* OPERATIONS *********/
}
